function camelise(str) {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, '');
}

const convertStringToBoolean = inputString => {
  if (typeof inputString === 'string') {
    if (inputString.toLowerCase() === 'true') {
      return true;
    } else if (inputString.toLowerCase() === 'false') {
      return false;
    }
  }
  return undefined;
};

const accentCharTranslations = {
  à: 'a',
  á: 'a',
  â: 'a',
  ä: 'a',
  æ: 'a',
  ã: 'a',
  å: 'a',
  ā: 'a',
  è: 'e',
  é: 'e',
  ê: 'e',
  ë: 'e',
  ē: 'e',
  ė: 'e',
  ę: 'e',
  î: 'i',
  ï: 'i',
  í: 'i',
  ī: 'i',
  į: 'i',
  ì: 'i',
  ô: 'o',
  ö: 'o',
  ò: 'o',
  ó: 'o',
  œ: 'o',
  ø: 'o',
  ō: 'o',
  õ: 'o',
  û: 'u',
  ü: 'u',
  ù: 'u',
  ú: 'u',
  ū: 'u',
  ç: 'c',
  ć: 'c',
  č: 'c',
  l: 'l',
  ñ: 'n',
  ń: 'n',
  ś: 's',
  š: 's',
  ÿ: 'y',
  ž: 'z',
  ź: 'z',
  ż: 'z',
};

function replaceAccentedCharacters(inputString) {
  if (typeof inputString === 'string') {
    return inputString
      .toLowerCase()
      .split('')
      .map(char => {
        return accentCharTranslations[char]
          ? accentCharTranslations[char]
          : char;
      })
      .join('');
  } else {
    console.warn(
      `string-helper-functions -> replaceAccentedCharacters: error, function called with non valid argument - inputString:`,
      inputString
    );
    return undefined;
  }
}

function slugify(inputString) {
  if (typeof inputString === 'string' && inputString.length) {
    const translatedInputString = replaceAccentedCharacters(inputString);
    return translatedInputString
      .replace(/_/g, '-') // replace _ with -
      .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
      .trim() // trim after removing invalid chars but before replacing whitespace with -
      .replace(/\s+/g, '-') // collapse whitespace and replace by -
      .replace(/-+/g, '-'); // collapse dashes
  } else {
    console.error(
      `string-helper-functions -> slugify: error, function called with non valid argument - inputString:`,
      inputString
    );
    return undefined;
  }
}

function orderQueryString(
  search,
  preferredOrder = ['sortBy', 'topics', 'contentType']
) {
  if (!search) return '';
  const sp = new URLSearchParams(
    search.startsWith('?') ? search.slice(1) : search
  );
  const out = new URLSearchParams();

  // Put preferred keys first (if present)
  for (const key of preferredOrder) {
    if (sp.has(key)) {
      out.set(key, sp.get(key));
      sp.delete(key);
    }
  }
  // Append any remaining keys in alphabetical order
  const leftoverKeys = Array.from(sp.keys()).sort();
  for (const key of leftoverKeys) {
    out.set(key, sp.get(key));
  }

  const str = out.toString();
  return str ? `?${str}` : '';
}

module.exports = {
  camelise,
  convertStringToBoolean,
  replaceAccentedCharacters,
  slugify,
  orderQueryString,
};
